export default {
    //智慧用气管理后台首页
    "useGas.index.824943-0": "Safety gas warning and monitoring system",
    "useGas.index.824943-1": "Region management",
    "useGas.index.824943-2": "Home",
    "useGas.index.824943-3": "User Management",
    "useGas.index.824943-4": "Device profile",
    "useGas.index.824943-5": "Device alarm",
    "useGas.index.824943-6": "Alarm Device",
    "useGas.index.824943-7": "Left menu",
    "useGas.index.824943-8": "You can freely choose the information content you want to view and click on the corresponding function menu button",

    //智慧用气大屏
    "bigScreen.index.925365-0": "Enter the system",
    "bigScreen.index.925365-1": "return",
    "bigScreen.index.925365-2": "Hangzhou City, Zhejiang Province",
    "bigScreen.index.925365-3": "All regions",
    "bigScreen.index.925365-4": "system",
    "bigScreen.index.925365-5": "Please select this function button to enter the background interface",
    "bigScreen.index.925365-6": "Zhejiang Province Hangzhou City",
    "bigScreen.index.925365-7": "time",
    "bigScreen.index.925365-8": "code",
    "bigScreen.index.925365-9": "name",
    "bigScreen.index.925365-10": "types of",
    "bigScreen.index.925365-11": "state",
    "bigScreen.index.925365-12": "position",
    "bigScreen.index.925365-13": "on line",
    "bigScreen.index.925365-14": "offline",
    "bigScreen.index.925365-15": "User Name",
    "bigScreen.index.925365-16": "Telephone",
    "bigScreen.index.925365-17": "Unit Name",
    "bigScreen.index.925365-18": "Device status",
    "bigScreen.index.925365-19": "Yahei",

    //区域管理
    "area.index.548708-0": "Add Area",
    "area.index.548708-1": "All regions",
    "area.index.548708-2": "There is currently no data available",


    //选择地址
    "mods.selectArea.004625-0": "Region selection",
    "mods.selectArea.004625-1": "save",
    "mods.selectArea.004625-2": "All regions",
    "mods.selectArea.004625-3": "There is currently no data available",

    //添加地址
    "add.index.424326-0": "save",
    "add.index.424326-1": "Superior Region",
    "add.index.424326-2": "Please select a region",
    "add.index.424326-3": "New Area",
    "add.index.424326-4": "Edit Region",


    //村
    "add.village.443671-0": "Village name",
    "add.village.443671-1": "Please enter the village name",
    "add.village.443671-2": "Search Address",
    "add.village.443671-3": "address",
    "add.village.443671-4": "longitude",
    "add.village.443671-5": "latitude",
    "add.village.443671-6": "Please enter the name of the township/street",
    "add.village.443671-7": "Longitude cannot be empty",
    "add.village.443671-8": "Latitude cannot be empty",

    //乡镇
    "add.town.433277-0": "Township/Street Name",
    "add.town.433277-1": "Please enter the name of the township/street",
    "add.town.433277-2": "Search Address",
    "add.town.433277-3": "address",
    "add.town.433277-4": "longitude",
    "add.town.433277-5": "latitude",
    "add.town.433277-6": "Longitude cannot be empty",
    "add.town.433277-7": "Latitude cannot be empty",

    //添加城市
    "add.city.415013-0": "economize",
    "add.city.415013-1": "Please select a province",
    "add.city.415013-2": "city",
    "add.city.415013-3": "Please select a city",
    "add.city.415013-4": "Address",
    "add.city.415013-5": "Please enter detailed address",
    "add.city.415013-6": "Please select a province",

    //添加区域
    "add.area.404510-0": "area name",
    "add.area.404510-1": "Please enter a region name",
    "add.area.404510-2": "Search Address",
    "add.area.404510-3": "address",
    "add.area.404510-4": "longitude",
    "add.area.404510-5": "latitude",
    "add.area.404510-6": "Longitude cannot be empty",
    "add.area.404510-7": "Latitude cannot be empty",


    //设备告警首页
    "device.index.508393-0": "Equipment number:",
    "device.index.508393-1": "Please enter the device number",
    "device.index.508393-2": "search for",
    "device.index.508393-3": "import",
    "device.index.508393-4": "All regions",

    //设备报警--设备状态
    "status.state.640567-0": "Device Name",
    "status.state.640567-1": "Presence",
    "status.state.640567-2": "on line",
    "status.state.640567-3": "offline",
    "status.state.640567-4": "Device Address",
    "status.state.640567-5": "Telephone",
    "status.state.640567-6": "not set",
    "status.index.756855-0": "Device status",
    "status.index.756855-1": "confirm",

    //设备报警 --设备编辑
    "edit.index.885685-0": "Modify device",
    "edit.index.885685-1": "save",
    "edit.index.885685-2": "Equipment coding",
    "edit.index.885685-3": "Please enter the device code",
    "edit.index.885685-4": "Device Name",
    "edit.index.885685-5": "Please enter a device name",
    "edit.index.885685-6": "contacts",
    "edit.index.885685-7": "Please enter a contact person",
    "edit.index.885685-8": "Telephone",
    "edit.index.885685-9": "Please enter the contact phone number",
    "edit.index.885685-10": "The device name cannot be empty",

    //设备告警--搜索设备
    "device.device.023557-0": "cell-phone number:",
    "device.device.023557-1": "Please enter your phone number",
    "device.device.023557-2": "Equipment number:",
    "device.device.023557-3": "Please enter the device number",
    "device.device.023557-4": "search for",
    "device.index.151764-0": "Select device",
    "device.index.151764-1": "confirm",
    "device.index.151764-2": "cell-phone number:",
    "device.index.151764-3": "Please enter your phone number",
    "device.index.151764-4": "Equipment number:",
    "device.index.151764-5": "Please enter the device number",
    "device.index.151764-6": "search for",

    //告警设备--添加设备 
    "add.index.213388-0": "Import Device",
    "add.index.213388-1": "import",
    "add.index.213388-2": "User",
    "add.index.213388-3": "Please select a user",
    "add.index.213388-4": "Please select the user you belong to",
    "add.index.213388-5": "Please select a device for selection",

    //用户管理--首页
    "user.index.373660-0": "newly added",
    "user.index.373660-1": "All regions",

    //用户管理--选择区域
    "village.index.527052-0": "Region selection",
    "village.index.527052-1": "save",
    "village.index.527052-2": "All regions",
    "village.index.527052-3": "There is currently no data available",

    //用户管理--添加

    "add.index.733618-0": "save",
    "add.index.733618-1": "Region",
    "add.index.733618-2": "Please select a region",
    "add.index.733618-3": "Building",
    "add.index.733618-4": "Please enter building",
    "add.index.733618-5": "unit",
    "add.index.733618-6": "Please enter the unit",
    "add.index.733618-7": "floor",
    "add.index.733618-8": "Please enter the floor",
    "add.index.733618-9": "User ID",
    "add.index.733618-10": "Please enter the user number",
    "add.index.733618-11": "Owners Name",
    "add.index.733618-12": "Please enter the owner's name",
    "add.index.733618-13": "Owner's phone number",
    "add.index.733618-14": "Please enter the owner's phone number",
    "add.index.733618-15": "customer type",
    "add.index.733618-16": "Please select a user type",
    "add.index.733618-17": "Merchant",
    "add.index.733618-18": "resident",
    "add.index.733618-19": "Unit Name",
    "add.index.733618-20": "Please enter the company name",
    "add.index.733618-21": "Life",
    "add.index.733618-22": "Please enter the service life",
    "add.index.733618-23": "Regional administrator",
    "add.index.733618-24": "Please enter the regional administrator",
    "add.index.733618-25": "Regional administrator phone number",
    "add.index.733618-26": "Please enter the phone number of the regional administrator",
    "add.index.733618-27": "Annual inspection status",
    "add.index.733618-28": "Please select the annual inspection status",
    "add.index.733618-29": "qualified",
    "add.index.733618-30": "unqualified",
    "add.index.733618-31": "Search Address",
    "add.index.733618-32": "address",
    "add.index.733618-33": "longitude",
    "add.index.733618-34": "latitude",
    "add.index.733618-35": "Address",
    "add.index.733618-36": "Please enter detailed address",
    "add.index.733618-37": "Validity period of verification certificate",
    "add.index.733618-38": "Please select a date",
    "add.index.733618-39": "Building cannot be empty",
    "add.index.733618-40": "Unit cannot be empty",
    "add.index.733618-41": "The floor cannot be empty",
    "add.index.733618-42": "User ID cannot be empty",
    "add.index.733618-43": "The owner's name cannot be empty",
    "add.index.733618-44": "The owner's phone number cannot be empty",
    "add.index.733618-45": "Unit name cannot be empty",
    "add.index.733618-46": "Service life cannot be empty",
    "add.index.733618-47": "Regional administrator cannot be empty",
    "add.index.733618-48": "Regional administrator phone number cannot be empty",
    "add.index.733618-49": "The detailed address cannot be empty",
    "add.index.733618-50": "New Users",
    "add.index.733618-51": "Edit user",
    "add.index.733618-52": "Region selection error, please select to the village in the region",

    //js内字段
    //报警列表
    "alarm.columns.097043-0": "Device Name",
    "alarm.columns.097043-1": "Device Number",
    "alarm.columns.097043-2": "Device Address",
    "alarm.columns.097043-3": "Online Status",
    "alarm.columns.097043-4": "Online",
    "alarm.columns.097043-5": "Offline",
    "alarm.columns.097043-6": "Device Condition",
    "alarm.columns.097043-7": "Closed",
    "alarm.columns.097043-8": "Open",
    "alarm.columns.097043-9": "User Name",
    "alarm.columns.097043-10": "Detailed Address",
    "alarm.columns.097043-11": "Longitude",
    "alarm.columns.097043-12": "Latitude",
    "alarm.columns.097043-13": "Operation",
    "alarm.columns.097043-14": "View Alarm",

    //地址表单

    "area.columns.127167-0": "Serial Number",
    "area.columns.127167-1": "Area Name",
    "area.columns.127167-2": "Creator",
    "area.columns.127167-3": "Creation Date",
    "area.columns.127167-4": "Operation",
    "area.columns.127167-5": "Edit",
    "area.columns.127167-6": "Prompt",
    "area.columns.127167-7": "Is Deleted",
    "area.columns.127167-8": "Delete",

    //提醒表单
    "alert.columns.114421-0": "Serial Number",
    "alert.columns.114421-1": "Device Name",
    "alert.columns.114421-2": "Device Number",
    "alert.columns.114421-3": "Alert Time",
    "alert.columns.114421-4": "Alert Type",
    "alert.columns.114421-5": "User Name",
    "alert.columns.114421-6": "Detailed Address",
    "alert.columns.114421-7": "Longitude",
    "alert.columns.114421-8": "Latitude",
    "alert.columns.114421-9": "Operation",
    "alert.columns.114421-10": "Handle",
    "alert.columns.114421-11": "False Alarm",
    "alert.columns.114421-12": "Processed",
    "alert.columns.114421-13": "Confirmation",

    //设备
    //设备添加
    "add.columns.331975-0": "Device Number",
    "add.columns.331975-1": "Device Name",
    "add.columns.331975-2": "Device Type",
    "add.columns.331975-3": "Micro-circuit Breaker Device",
    "add.columns.331975-4": "Door Lock Device",
    "add.columns.331975-5": "Smoke Detection Device",
    "add.columns.331975-6": "Gas Detection Device",
    "add.columns.331975-7": "Zigbee Device",
    "add.columns.331975-8": "Surveillance Device",
    "add.columns.331975-9": "Operation",

    //设备设备
    "device.columns.586949-0": "Device Number",
    "device.columns.586949-1": "Device Name",
    "device.columns.586949-2": "Device Type",
    "device.columns.586949-3": "Micro-circuit Breaker Device",
    "device.columns.586949-4": "Door Lock Device",
    "device.columns.586949-5": "Smoke Detection Device",
    "device.columns.586949-6": "Gas Detection Device",
    "device.columns.586949-7": "Zigbee Device",
    "device.columns.586949-8": "Surveillance Device",
    "device.columns.586949-9": "Online",
    "device.columns.586949-10": "Offline",
    "device.columns.586949-11": "Device Address",

    //设备设备
    "device.columns.805635-0": "Serial Number",
    "device.columns.805635-1": "Device Name",
    "device.columns.805635-2": "Device Code",
    "device.columns.805635-3": "Device Status",
    "device.columns.805635-4": "Online",
    "device.columns.805635-5": "Offline",
    "device.columns.805635-6": "Last Online Time",
    "device.columns.805635-7": "Last Offline Time",
    "device.columns.805635-8": "Specification Model",
    "device.columns.805635-9": "Rated Current",
    "device.columns.805635-10": "Rated Voltage",
    "device.columns.805635-11": "Configured Function",
    "device.columns.805635-12": "Online Rate",
    "device.columns.805635-13": "Device Address",
    "device.columns.805635-14": "Longitude",
    "device.columns.805635-15": "Latitude",
    "device.columns.805635-16": "Creation Date",
    "device.columns.805635-17": "Operation",
    "device.columns.805635-18": "Status",
    "device.columns.805635-19": "Edit",
    "device.columns.805635-20": "Prompt",
    "device.columns.805635-21": "Deleted",
    "device.columns.805635-22": "Delete",

    //设备用户
    "user.columns.016995-0": "Serial Number",
    "user.columns.016995-1": "User Name",
    "user.columns.016995-2": "Unit Name",
    "user.columns.016995-3": "Contact Phone",
    "user.columns.016995-4": "User Type",
    "user.columns.016995-5": "Merchant",
    "user.columns.016995-6": "Resident",
    "user.columns.016995-7": "Number of Gas Alarms",
    "user.columns.016995-8": "Number of Gas Relays",
    "user.columns.016995-9": "Operating Status",
    "user.columns.016995-10": "Normal",
    "user.columns.016995-11": "Abnormal",
    "user.columns.016995-12": "Service Life",
    "user.columns.016995-13": "District Manager",
    "user.columns.016995-14": "District Manager Phone",
    "user.columns.016995-15": "Annual Inspection Status",
    "user.columns.016995-16": "qualified",
    "user.columns.016995-17": "unqualified",
    "user.columns.016995-18": "Calibration Certificate Expiry Date",
    "user.columns.016995-19": "Operation",
    "user.columns.016995-20": "Device",
    "user.columns.016995-21": "Prompt",
    "user.columns.016995-22": "Whether to delete?",
    "user.columns.016995-23": "Delete"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/En/useGas-en.js